import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {}

  registerIcon(name: string, url: string): void {
    if (!url) return;
    this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(url));
  }

  registerIconSet(url: string): void {
    if (!url) return;
    this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl(url));
  }

  registerIconNamespace(url: string, namespace: string): void {
    if (!url) return;
    this.matIconRegistry.addSvgIconSetInNamespace(namespace, this.domSanitizer.bypassSecurityTrustResourceUrl(url));
  }
}
